export default "__VITE_ASSET__2noNtW9T__"